<app-deal-status-picker
  class="tw-w-full"
  [status]="status"
  [options]="statusOptions"
  (change)="handleStatusChange($event)">
</app-deal-status-picker>
